import {
  FUND_INVESTMENTS_DOCUMENTS_SLUG,
  FUND_INVESTMENTS_DOCUMENTS_TITLE,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_TITLE,
  FUND_INVESTMENTS_SUMMARY_SLUG,
  FUND_INVESTMENTS_SUMMARY_TITLE,
} from 'pages/FundInvestments/common/constants';
import {
  getFundInvestmentsDocumentsUrl,
  getFundInvestmentsMarketAdjustmentUrl,
  getFundInvestmentsSummaryUrl,
} from 'pages/FundInvestments/common/urls';

export const FUND_INVESTMENTS_PAGES = [
  {
    id: 0,
    slug: FUND_INVESTMENTS_SUMMARY_SLUG,
    title: FUND_INVESTMENTS_SUMMARY_TITLE,
  },
  {
    id: 1,
    slug: FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG,
    title: FUND_INVESTMENTS_MARKET_ADJUSTMENT_TITLE,
  },
  {
    id: 2,
    slug: FUND_INVESTMENTS_DOCUMENTS_SLUG,
    title: FUND_INVESTMENTS_DOCUMENTS_TITLE,
  },
];

export const FUND_INVESTMENTS_MENU_ITEMS = [
  {
    callback: getFundInvestmentsSummaryUrl,
    id: FUND_INVESTMENTS_SUMMARY_SLUG,
    itemKey: 0,
    slug: FUND_INVESTMENTS_SUMMARY_SLUG,
    title: FUND_INVESTMENTS_SUMMARY_TITLE,
  },
  {
    callback: getFundInvestmentsMarketAdjustmentUrl,
    id: FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG,
    itemKey: 1,
    slug: FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG,
    title: FUND_INVESTMENTS_MARKET_ADJUSTMENT_TITLE,
  },
  {
    callback: getFundInvestmentsDocumentsUrl,
    id: FUND_INVESTMENTS_DOCUMENTS_SLUG,
    itemKey: 2,
    slug: FUND_INVESTMENTS_DOCUMENTS_SLUG,
    title: FUND_INVESTMENTS_DOCUMENTS_TITLE,
  },
];

export const FUND_INVESTMENTS_AVAILABLE_SLUG_PARAMS = FUND_INVESTMENTS_PAGES.map(({ slug }) => slug);
